// Generated with: https://maketintsandshades.com/
// base color: GREY_50
// export const GREY_10 = '';
export const GREY_20 = '#222426';
// export const GREY_30 = '';
// export const GREY_40 = '';
export const GREY_50 = '#808080';
export const GREY_60 = '#a0a0a0';
export const GREY_70 = '#c0c0c0';
export const GREY_80 = '#e2e2e2';
export const GREY_90 = '#f7f8fa';

export const WHITE = '#ffffff';
export const BLACK = '#000000';
export const GREY = '#3c414c';

export const AQUA = '#70e6ff';
export const GREEN = '#00b16a';
export const ORANGE = '#faad14';
export const RED = '#ee1111';
export const MAGENTA = '#ff7895';
export const BLUE = '#627eea';

export const OCEAN = '#607d8b';

export const TIER_1 = '#c1c9d2';
export const TIER_2 = '#7779ff';
export const TIER_3 = '#fc4e7c';

export const LAG = '#fdf1d0';

export const SPARKLINE = '#b0bec5';

export const GRADIENT_SPECTRAL = [
  '#5e4fa2',
  '#3184bc',
  '#47baae',
  '#98d6a4',
  '#ceed9c',
  '#f5faad',
  '#feed9a',
  '#fece79',
  '#fb9d56',
  '#ef6445',
  '#d0394e',
  '#9e0142',
];

export const GRADIENT_INFERNO = [
  '#fcffa4',
  '#f4df53',
  '#fbb61a',
  '#f98e09',
  '#ed6925',
  '#d84c3e',
  '#bc3754',
  '#9a2865',
  '#781c6d',
  '#57106e',
  '#320a5e',
  '#110a30',
  '#000004',
];

export const GRADIENT_TURBO = ['#eb4444', '#f78410', '#f5db4c', '#26c811', '#4467eb'];

export const GRADIENT_TURBO_ALT = [
  '#ff4b5f',
  '#ff9127',
  '#ffd300',
  '#a2ff34',
  '#00e376',
  '#00cfba',
  '#00abf8',
  '#4478f4',
  '#b352f2',
  '#ff60ff',
];

export const GRADIENT_SUPPLY_LTH_STH = ['#ea4649', '#f5a3a5', '#9caff2', '#4467e5'];

export const MINERS_COLOR_DICT = {
  BitMinter: '#ff4b5f',
  BitFury: '#ff9127',
  AntPool: '#ffd300',
  ViaBTC: '#a2ff34',
  DPool: '#00e376',
  'BTC.com': '#00cfba',
  BinancePool: '#00abf8',
  Bixin: '#4478f4',
  F2Pool: '#b352f2',
  '1THash&58COIN': '#ff60ff',
  NovaBlock: '#ff4b5f',
  'BTC.TOP': '#ff9127',
  SlushPool: '#ffd300',
  OKExPool: '#a2ff34',
  Poolin: '#00e376',
  HuobiPool: '#00cfba',
  BitcoinRussia: '#ff4b5f',
  Eobot: '#ff9127',
  SigmaPool: '#ffd300',
  KanoPool: '#a2ff34',
  'Bitcoin.com': '#00e376',
  'solo.ckpool.org': '#00cfba',
  Tigerpool: '#00abf8',
  MiningCity: '#4478f4',
  UKRPool: '#b352f2',
  SpiderPool: '#ff60ff',
  Satoshi: '#ff4b5f',
  'taal.com': '#ff9127',
  BytePool: '#a2ff34',
  'Lubian.com': '#00e376',
  other: '#00abf8',
};

export const EXCHANGES_COLOR_DICT = {
  'bitcoin.de': '#a2ff34',
  luno: '#00e376',
  bitstamp: '#00cfba',
  poloniex: '#00abf8',
  gemini: '#4478f4',
  huobi: '#b352f2',
  kraken: '#ff60ff',
  hitbtc: '#ff4b5f',
  bittrex: '#ff9127',
  bitfinex: '#ffd300',
  okex: '#a2ff34',
  bitmex: '#00e376',
  binance: '#00cfba',
  coinbase: '#00abf8',
};

export const HASH_RIBBON_COLOR_DICT = {
  ma30: '#00E376',
  ma60: '#4478F4',
};

export const EXCHANGE_FEES_COLOR_DICT = {
  total: GREY,
  deposit: '#ff60ff',
  withdrawal: '#00abf8',
  inhouse: '#00e376',
  inter: '#a2ff34',
};

export const COMPARE_COLORS = [...GRADIENT_TURBO_ALT, OCEAN, GREY, BLACK];
